import { combineReducers } from 'redux';

import settingsPane from './settingsPane';
import rightPane from './rightPane';

export default combineReducers({
  settingsPane,
  rightPane
});
